import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/login", { replace: true }); return; }
      const session_id = decodeURIComponent(m[1]);
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data?.session_token) localStorage.setItem("ths_session_token", data.session_token);
        const user = await refresh();
        if (user?.role === "patient") {
          toast.error("Patient sign-in has been removed. Please contact your facility for your records.");
          navigate("/login", { replace: true });
          return;
        }
        toast.success(`Welcome, ${user?.name || "user"}`);
        navigate("/app", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-600" data-testid="auth-callback-screen">
      Signing you in…
    </div>
  );
}
